import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationStaffCategoryOnboardResponse,
  IConfigurationtStaffCategoryOnboardPostBody,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffCategoryOnboardAPI = () => {
  const [newStaffCategoryId, setNewStaffCategoryId] = useState<string>("");
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (staffCategoryData: IConfigurationtStaffCategoryOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!staffCategoryData) {
          return;
        }
        await axios
          .post(CONFIGURATION_APIS?.STAFF_CATEGORY_ONBOARD?.baseURL ?? "", staffCategoryData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffCategoryOnboardResponse>) => {
            if (res.data.status === true) {
              setNewStaffCategoryId(res.data.data.staff_category_id);
              toast.success(`${staffCategoryData?.category_name} has been added. `);
            } else {
              toast.error("Error while onboarding staff category.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Staff Category already exists");
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { newStaffCategoryId, execute };
};
